import { Button, InlineError, LegacyStack, Tag, Text } from '@shopify/polaris'
import React, { useCallback } from 'react'

import { gidToId, useToggle } from '../common/helpers'
import { LegacyHelpIcon } from '../common/HelpIcon'
import { useShopCurrency } from '../common/Price'
import { ProductVariantModal, ProductVariantResult } from '../common/ProductVariantModal'
import {
  WorkflowAction,
  workflowActionLabels,
  WorkflowProductDataType,
} from '../common/workflow-models'

export const RemoveProductVariantAction = ({
  params,
  onChange,
  index,
  error,
}: {
  params: WorkflowProductDataType
  onChange: (action: WorkflowAction, index: number) => any
  index: number
  error: string | null
}) => {
  const shopCurrency = useShopCurrency()
  const [productModalActive, toggleProductModalActive] = useToggle(false)

  const handleUpdate = useCallback(
    (selected: ProductVariantResult) => {
      onChange(['remove-product-variant', [gidToId(selected.id), selected.title]], index)
      toggleProductModalActive()
    },
    [index, onChange, toggleProductModalActive]
  )

  return (
    <>
      <LegacyStack vertical>
        <Text variant="headingSm" as="h2">
          {workflowActionLabels['remove-product-variant']}
          <LegacyHelpIcon>
            Line items that match the selected product variant will be removed from the
            subscription. Removal will fail if there are no line items left in the subscription.
          </LegacyHelpIcon>
        </Text>

        {params.length === 0 && (
          <Text as="span" tone="subdued">
            No variant selected
          </Text>
        )}

        {params[0] && <Tag key={params[0]}>{params[1]}</Tag>}

        <Button onClick={toggleProductModalActive} size="slim">
          Select product variant
        </Button>
        {error && <InlineError message={error} fieldID="" />}
      </LegacyStack>
      <ProductVariantModal
        currency={shopCurrency}
        open={productModalActive}
        onClose={toggleProductModalActive}
        onSelect={handleUpdate}
      />
    </>
  )
}
